import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./OrganizationClassificationUIHelpers";

const OrganizationClassificationUIContext = createContext();

export function useOrganizationClassificationUIContext() {
  return useContext(OrganizationClassificationUIContext);
}

export const OrganizationClassificationUIConsumer =
  OrganizationClassificationUIContext.Consumer;

export function OrganizationClassificationUIProvider({
  organizationClassificationUIEvents,
  children
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initOrganizationClassification = {
    name: "",
    description: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initOrganizationClassification,
    newOrganizationClassificationButtonClick:
      organizationClassificationUIEvents.newOrganizationClassificationButtonClick,
    openEditOrganizationClassificationPage:
      organizationClassificationUIEvents.openEditOrganizationClassificationPage,
    openOrganizationClassificationFilePage:
      organizationClassificationUIEvents.openOrganizationClassificationFilePage
  };

  return (
    <OrganizationClassificationUIContext.Provider value={value}>
      {children}
    </OrganizationClassificationUIContext.Provider>
  );
}
